import { FC, useEffect, useState } from 'react'
import {
  useUsersActivity,
  useCollectionActivity,
} from '@reservoir0x/reservoir-kit-ui'
import axios from 'axios'
import { ItemActivityTable } from 'components/common/ItemActivityTable'
import { useRouter } from 'next/router'

type ActivityQuery = NonNullable<
  Exclude<Parameters<typeof useUsersActivity>['1'], boolean>
>
type ActivityTypes = Exclude<ActivityQuery['types'], string>

type Props = {
  user: string | undefined
  activityTypes: ActivityTypes
}

type CollectionActivityResponse = ReturnType<typeof useCollectionActivity>
export type CollectionActivityTypes = NonNullable<
  Exclude<Parameters<typeof useCollectionActivity>['0'], boolean>
>['types']

type UsersActivityResponse = ReturnType<typeof useCollectionActivity>
type ActivityResponse = CollectionActivityResponse | UsersActivityResponse

export const UserActivityTable: FC<Props> = ({ user, activityTypes }) => {
  const router = useRouter()
  const tokenId = router.query.assetId

  const [activities, setActivities] = useState<
    ActivityResponse['data'] | undefined
  >(undefined)
  const [dataSize, setDataSize] = useState<number>(1)
  const [continuation, setContinuation] = useState<string | undefined>(
    undefined
  )

  useEffect(() => {
    setActivities(undefined)
    setContinuation(undefined)
    setDataSize(1)
    const fetchData = async () => {
      if (dataSize > 1 && !continuation) return
      try {
        const response = await axios.get('/api/getItemActivity', {
          params: {
            tokenId: tokenId,
            types: activityTypes,
            continuation: continuation,
            limit: 20,
          },
        })
        if (response && response.data) {
          setActivities(response.data.activities)
          setContinuation(response.data.continuation)
        }
      } catch (error) {
        console.error('Failed to fetch stats', error)
      }
    }
    fetchData()
  }, [activityTypes])

  useEffect(() => {
    const fetchData = async () => {
      if (dataSize > 1 && !continuation) return
      try {
        const response = await axios.get('/api/getItemActivity', {
          params: {
            tokenId: tokenId,
            types: activityTypes,
            continuation: continuation,
            limit: 20,
          },
        })
        if (response && response.data) {
          if (activities) {
            setActivities([...activities, ...response.data.activities])
          } else {
            setActivities(response.data.activities)
          }
          setContinuation(response.data.continuation)
        }
      } catch (error) {
        console.error('Failed to fetch stats', error)
      }
    }
    fetchData()
  }, [dataSize])

  return (
    <ItemActivityTable
      activitise={activities}
      dataSize={dataSize}
      setDataSize={setDataSize}
    />
  )
}
